var itit = {
	"coupon-callout": {
	"coupon-code": "Codice",
	"coupon-message-with-price": "Solo {{ price }}",
	"coupon-expiry-message": "Scade {{ Date }}.",
	"code-at-checkout": "Inserisci il codice alla conferma dell’ordine. Non cumulabile con altri codici sconto, promozioni o sconti.",
	"cancel-icon": "Annulla",
	"info-icon": "Vedi dettagli",
	"check-icon": "Applicata",
	"promo-code": "Codice sconto",
	"coupon-callout-popover": "Popover callout del codice"
}
};

export { itit as default };
//# sourceMappingURL=src-localization-texts-it-it.json.js.map
